import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function UserLock({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M15.57 16.42V14.99C15.57 13.88 16.459 12.99 17.569 12.99C18.669 12.99 19.569 13.88 19.569 14.99V16.41M11 15H7C4.79 15 3 16.79 3 19V20M15.57 16.428H19.571C20.3597 16.428 20.999 17.0673 20.999 17.856V19.571C20.999 20.3597 20.3597 20.999 19.571 20.999H15.57C14.7813 20.999 14.142 20.3597 14.142 19.571V17.856C14.142 17.0673 14.7813 16.428 15.57 16.428ZM11 3C9.93913 3 8.92172 3.42143 8.17157 4.17157C7.42143 4.92172 7 5.93913 7 7C7 8.06087 7.42143 9.07828 8.17157 9.82843C8.92172 10.5786 9.93913 11 11 11C12.0609 11 13.0783 10.5786 13.8284 9.82843C14.5786 9.07828 15 8.06087 15 7C15 5.93913 14.5786 4.92172 13.8284 4.17157C13.0783 3.42143 12.0609 3 11 3Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default UserLock;